<template><div><h3>Alert_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Falert"/>
<p><a href="https://vux.li/demos/v2/#/component/alert" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/alert</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/alert" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Show Me')"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">alert</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show"</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Congratulations')"</span> <span class="hljs-attr">@on-show</span>=<span class="hljs-string">"onShow"</span> <span class="hljs-attr">@on-hide</span>=<span class="hljs-string">"onHide"</span>&gt;</span> <span>{{</span> $t('Your Message is sent successfully~') <span>}}</span><span class="hljs-tag">&lt;/<span class="hljs-name">alert</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">group</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Prop: content"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-switch</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Show Me')"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show2"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-transfer-dom</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">alert</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"show2"</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Congratulations')"</span> <span class="hljs-attr">:content</span>=<span class="hljs-string">"$t('Your Message is sent successfully~')"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">alert</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">group</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Use as a plugin')"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Show Me')"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showPlugin"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">cell</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Will auto close in 3s')"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showPluginAuto"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">cell</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">group</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Use as a module')"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Show Me')"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showModule"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">cell</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Will auto close in 3s')"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showModuleAuto"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">cell</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>



<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { AlertModule, Alert, Group, XSwitch, Cell, TransferDomDirective <span class="hljs-keyword">as</span> TransferDom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">directives</span>: {
    TransferDom
  },
  <span class="hljs-attr">components</span>: {
    Alert,
    Group,
    XSwitch,
    Cell
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">show</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">show1</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">show2</span>: <span class="hljs-literal">false</span>
    }
  },
  <span class="hljs-attr">methods</span>: {
    onHide () {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'on hide'</span>)
    },
    onShow () {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'on show'</span>)
    },
    showPlugin () {
      <span class="hljs-keyword">this</span>.$vux.alert.show({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'VUX is Cool'</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-keyword">this</span>.$t(<span class="hljs-string">'Do you agree?'</span>),
        onShow () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m showing'</span>)
        },
        onHide () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Plugin: I\'m hiding now'</span>)
        }
      })
    },
    showModule () {
      AlertModule.show({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'VUX is Cool'</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-keyword">this</span>.$t(<span class="hljs-string">'Do you agree?'</span>),
        onShow () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Module: I\'m showing'</span>)
        },
        onHide () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'Module: I\'m hiding now'</span>)
        }
      })
    },
    showModuleAuto () {
      <span class="hljs-keyword">this</span>.showModule()
      setTimeout(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
        AlertModule.hide()
      }, <span class="hljs-number">3000</span>)
    },
    showPluginAuto () {
      <span class="hljs-keyword">this</span>.showPlugin()
      setTimeout(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
        <span class="hljs-keyword">this</span>.$vux.alert.hide()
      }, <span class="hljs-number">3000</span>)
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// alert-356.vue?0658ea5a